import { Button } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from "react-router-dom";

import { Text18 } from '../../ui/Text18';
import { successPageIcon } from '../../constants';
import DownloadIcon from '@mui/icons-material/Download';
import { 
  Wrapper, 
  Content,
  ImageWrapper,
  Image,
  InfoWrapper,
  InfoTitle,
  InfoDesc,
  ButtonWrapper 
} from './index.style';
import { devUrl } from '../../constants';

const SuccessPage: React.FC<{}> = () => {
  let [searchParams] = useSearchParams();  
  const { t } = useTranslation();
  const transactionId = searchParams.get('transaction');
  const isDev = process.env.NODE_ENV === 'development';
  const baseURL = isDev ? `${devUrl}pdf/insurance/${transactionId}` : `/pdf/insurance/${transactionId}`;

  const handleDownloadPDF = async () => { 
    let filename = ''; 
    await fetch(baseURL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      }      
    })
    .then((response) => {
      const header = response.headers.get('Content-Disposition');
      const parts = header.split(';');
      filename = parts[1].split('=')[1].split('/').join('');  
      return response.blob();
    })
    .then((blob) => {
      if (blob != null) {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
      }        
    });   
  } 

  return (
    <Wrapper>
      <Content>
        <ImageWrapper>
          <Image src={successPageIcon} />
        </ImageWrapper>        
        <InfoWrapper>
          <InfoTitle>{t('success_title')}</InfoTitle>
          <InfoDesc>{t('success_desc')}</InfoDesc>
          <ButtonWrapper>
            <Button 
              variant='contained' 
              startIcon={<DownloadIcon />}
              onClick={handleDownloadPDF}
            >
              <Text18>{t('success_button')}</Text18>
            </Button>
          </ButtonWrapper>
        </InfoWrapper>
      </Content>
    </Wrapper>
  );
};

export default SuccessPage;
